// src/pages/SuccessPage.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Text from '../components/Text';

const SuccessPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate(); // Hook para la navegación

  const [paymentMethod, setPaymentMethod] = useState(null); // Para identificar si es Stripe o PayPal
  const [transactionId, setTransactionId] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);

    // Verificar si es un pago de Stripe o PayPal basado en los parámetros de la URL
    if (urlParams.has('session_id')) {
      setPaymentMethod('stripe');
      setTransactionId(urlParams.get('session_id')); // session_id de Stripe
    } else if (urlParams.has('invoice_id')) {
      setPaymentMethod('paypal');
      setTransactionId(urlParams.get('invoice_id')); // invoice_id de PayPal
    }
  }, [location]);

  const handleBackToInvoices = () => {
    // Navegar al listado de facturas
    navigate('/'); // Asegúrate de que esta ruta exista en tu aplicación
  };

  return (
    <div>
      <Text text={t('thanks')} whiteSpace="nowrap" flexGrow="1" textAlign="center" />
      <Text text={t('payment-completed-successfully')} whiteSpace="nowrap" flexGrow="1" textAlign="center" />

      {paymentMethod && (
        <div className="text-dark pb-2 fw-bold text-center">
          <strong>
            {paymentMethod === 'stripe' ? t('payment-made-with-stripe') : t('payment-made-with-paypal')}
          </strong>
          <p>{t('transaction-id')}: {transactionId}</p>
        </div>
      )}

      <div style={styles.buttonContainer}>
        <button onClick={handleBackToInvoices} className="btn-sm btn-paynow-ipb">
          {t('back-to-invoices')}
        </button>
      </div>
    </div>
  );
};

const styles = {
  buttonContainer: {
    display: 'flex', // Usamos Flexbox en el contenedor
    justifyContent: 'center', // Centra el botón horizontalmente
    alignItems: 'center', // Centra el botón verticalmente
    height: '10vh', // Asegura que ocupe toda la altura de la ventana
  },
};

export default SuccessPage;
